import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

import './LoginButton.scss';

const LoginButton = ({ i18n, id }) => (
    <LocalizedNavLink
        id={id}
        className="bt bt-fifth login-button"
        to={PATH.LOGIN_PATH}
        title={i18n.LOG_IN}>
        <SvgComponent
            src={`${STATIC_ROOT}/lock.svg`}
            alt=""
            width="29"
            height="24"
            aria-hidden="true"
            focusable="false"
        />
        <span>{i18n.LOG_IN}</span>
    </LocalizedNavLink>
);

LoginButton.propTypes = {
    i18n: PropTypes.object.isRequired,
    id: PropTypes.string
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.header.MEMBER_NAV
});

export default connect(mapStateToProps)(LoginButton);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoginButton.js